import { HTMLAttributes, useContext } from 'react';

import { twMerge } from 'tailwind-merge';

import { ModalContext, SIZES } from './context';

interface ModalHeaderProps extends HTMLAttributes<HTMLDivElement> {}

function ModalHeader({ children, className, ...props }: ModalHeaderProps) {
  const { size } = useContext(ModalContext);

  return (
    <div {...props} className={twMerge(SIZES[size].header, className)}>
      {children}
    </div>
  );
}

export { ModalHeader };
